import React, { useState } from 'react'
import Select from "react-select"

import { useListData } from '../../modules'

import Modal from "../reusable/modal"

const Ingredients = ({ toggle, visible, onSave, ingredients = [] }) => {
    const [selected, setSelected] = useState(ingredients)
    const [string, setString] = useState('')

    const [
        { loading: invLoading, fetch: fetchInvItems }, 
        { list: items = [] }
    ] = useListData('inventoryItems', { string }, { notify: true }, 'items')

    const search = str => {
        if (str?.trim()?.length > 2) {
            setString(str)
            fetchInvItems()
        }
    }

    const editQty = (index, val) => {
        let temp = [...selected]
        temp[index].qty = val
        setSelected(temp)
    }

    let notOk = selected.length === 0 || selected.some(itm => !itm.qty)

    const save = () => {
        onSave(selected)
        toggle()
    }

    return (
        <Modal
            w={ 500 }
            title="Ingredients"
            toggle={toggle}
            visible={visible}>
            <div className="flex mb-2 justify-center">
                <Select
                    isMulti
                    isLoading={invLoading}
                    loadingMessage={string => `Searching for "${string?.inputValue}"`}
                    onInputChange={search}
                    value={selected}
                    onChange={setSelected}
                    styles={{ input: styles => ({ ...styles, minWidth: '15em' }) }}
                    options={items.map(item => ({ label: item.name, value: item._id, ...item, qty: 0 }))}
                    placeholder="Search for inventory item" />
            </div>
            {
                selected.length > 0 &&
                <table className="table-auto w-full">
                    {/* Table header */}
                    <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                        <tr>
                            <th className="p-2">
                                <div className="font-semibold text-left">No.</div>
                            </th>
                            <th className="p-2">
                                <div className="font-semibold text-left">Item</div>
                            </th>
                            <th className="p-2">
                                <div className="font-semibold text-left">Quantity</div>
                            </th>
                        </tr>
                    </thead>
                    {/* Table body */}
                    <tbody className="text-sm font-medium divide-y divide-gray-100">
                        {
                            selected?.map((item, key) =>
                                <tr>
                                    <td className="p-2 text-center items-left h-5">{key + 1}</td>
                                    <td className="p-2 text-center items-left h-5">{item.label}</td>
                                    <td className="p-2 text-left items-center">
                                        <input 
                                            className="bg-gray-50 min-w-36 text-center border-gray-300 focus:ring-3 w-20 focus:ring-blue-300 rounded" 
                                            id="ing-qty" 
                                            placeholder={ `In ${item.issuedIn} `}
                                            aria-describedby="ing-qty" 
                                            type="number" 
                                            onChange={ e => editQty(key, e.target.value) }
                                            defaultValue={ item.qty }
                                            required />
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            }
            <div className="flex justify-end">
                <button disabled={ notOk } onClick={ save } type="submit" className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save</button>
            </div>
        </Modal>
    )
}

export default Ingredients